<template>
  <div
    :class="[
      'card',
      { 'card-no-padding': props.disablePadding, borderless: props.borderless }
    ]"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  disablePadding: { type: Boolean, default: false },
  borderless: { type: Boolean, default: false }
});
</script>

<style scoped>
.card {
  background: var(--neutral-surface-subtle);

  border-radius: var(--corner-radius-c-16);
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);

  &:not(.card-no-padding) {
    padding: var(--pad-space-sp-24);
  }

  &:not(.borderless) {
    border: var(--border-width-b-1) solid var(--neutral-border-subtle);
  }
}
</style>
